import React, { useState } from "react";
import RefreshButton from "../../../components/RefreshButton";
import SearchButton from "../../../components/SearchButton";
import TextInput from "../../../components/TextInput";

interface IProps {
  textInputName?: string;
  moduleDetails?: string;
  disabledButton?: boolean;
  setFilterText?;
  setIsSearching?;
  setIsFromRecent?;
  isFromRecent?: boolean;
  setFilterCustomData;
}
const TableFilters: React.FC<IProps> = ({
  textInputName,
  moduleDetails,
  disabledButton = false,
  setFilterText,
  setIsSearching,
  setIsFromRecent,
  isFromRecent,
  setFilterCustomData,
}) => {
  const [inputValue, setInputValue] = useState("");

  const FilterData = () => {
    setFilterText(inputValue);
    setIsSearching(true);
  };
  return (
    <>
      <div className="flex flex-row space-x-2">
        <TextInput
          type={textInputName}
          name={textInputName}
          value={inputValue}
          placeholder={moduleDetails}
          onChange={(e) => {
            setInputValue(e.target.value);
            if (e.target.value === "") {
              setFilterText("");
            }
          }}
        />
        <SearchButton
          buttonValue="Search"
          className={
            inputValue === "" || disabledButton ? "opacity-50" : "opacity-100"
          }
          disabled={inputValue === "" || disabledButton ? true : false}
          onClick={() => {
            FilterData();
          }}
        />
        <div>
          <RefreshButton
            className={
              isFromRecent
                ? "opacity-100"
                : inputValue === "" || disabledButton
                ? "opacity-50"
                : "opacity-100"
            }
            disabled={isFromRecent ? false : inputValue === "" ? true : false}
            onClick={() => {
              if (!disabledButton) {
                setFilterText && setFilterText("");
                setInputValue && setInputValue("");
                setIsFromRecent && setIsFromRecent(false);
                setFilterCustomData([]);
              }
            }}
          />
        </div>
      </div>
    </>
  );
};

export default TableFilters;
